import styled from '@emotion/styled'

export const StepHeader = styled.div`
  font-family: Satoshi;
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: 0%;
  text-align: center;
`
